'use client';

import dynamic from 'next/dynamic';

const GoodsListSeoBlockDynamic = dynamic(() => import('./GoodsListSeoBlock'), { ssr: false });

export default GoodsListSeoBlockDynamic;
